import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useLocalSearchParams } from 'expo-router';
import { ProjectProvider } from '../lib/ProjectContext';
import colors from '../lib/colors';
import { Trans } from '@lingui/react/macro';

interface WithProjectProviderProps {
    children: React.ReactNode;
}

/**
 * Higher-order component that wraps a screen with ProjectProvider
 * Handles the digestId parameter and error states
 */
export function withProjectProvider<P extends object>(
    Component: React.ComponentType<P>
): React.FC<P> {
    return function WrappedComponent(props: P) {
        const { digestId } = useLocalSearchParams<{ digestId: string }>();

        if (!digestId) {
            return (
                <View style={styles.errorContainer}>
                    <Text style={styles.errorText}><Trans id="withprojectprovider.noProjectIdProvided" comment="UI copy in components/withProjectProvider.tsx">No project ID provided</Trans></Text>
                </View>
            );
        }

        return (
            <ProjectProvider projectId={digestId}>
                <Component {...props} />
            </ProjectProvider>
        );
    };
}

const styles = StyleSheet.create({
    errorContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        padding: 20,
    },
    errorText: {
        fontSize: 16,
        color: colors.errorRed,
        textAlign: 'center',
    },
});
